import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum ComfortLevel {
  Never = 'Never',
  Learning = 'Learning',
  Reguarly = 'Regularly',
  CantDo = 'CantDo',
}

const comfortQuestion = {
  name: 'comfort',
  title: loc("quiz.comfort.title"),
  description: loc("quiz.comfort.description"),
  type: 'radiogroup',
  choices: [
    {
      value: ComfortLevel.Never,
      text: locIconButton("quiz.comfort.choices.never", "😬"),
    },
    {
      value: ComfortLevel.Learning,
      text: locIconButton("quiz.comfort.choices.learning", "🧑‍🔬"),
    },
    {
      value: ComfortLevel.Reguarly,
      text: locIconButton("quiz.comfort.choices.regularly", "✅"),
    },
    {
      value: ComfortLevel.CantDo,
      text: locIconButton("quiz.comfort.choices.cantDo", "🛑"),
    },
  ],
  isRequired: true,
};

export {
  ComfortLevel,
  comfortQuestion,
}